import React from 'react'
import TrainerList from '../../features/admin/TrainerList'

const TrainerListPage = () => {
  return <TrainerList />
}

export default TrainerListPage